<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="inputValue.state"
    :invalid-feedback="inputValue.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <quill-editor
      ref="quillEditor"
      :id="id"
      v-model="inputValue.value"
      :state="inputValue.state"
      :options="editorOptions"
      v-on:change="removeInvalidFeedback"
      :placeholder="placeholder"
      :disabled="quill_disabled">
    </quill-editor>
    <!-- necessaire pour la gestion du required, car cet attribut n'existe pas sur quill editor -->
    <b-form-input
      class="input-required"
      v-model="inputValue.value"
      :required="isRequired"></b-form-input>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>

export default {
  name: 'RichTextField',

  props: {
    inputValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    },
    editorOptions: {
      type: Object,
      default: function() {
        return {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['link'],
              ['blockquote'],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'script': 'sub'}, {'script': 'super'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'direction': 'rtl'}],

              [{'header': [1, 2, 3, 4, 5, 6, false]}],

              [{ 'color': [] }, { 'background': [] }],
              [{'font': []}],
              [{'align': []}],
              ['clean']
            ]
          }
        }
      }
    }
  },

  data() {
    return {
      quill_disabled: true
    }
  },

  mounted() {
    // gestion de l'annulation de l'autofocus sur l'editor à l'initialisation du contenu
    const quill = this.$refs.quillEditor.quill
    quill.on('editor-change', () => {
      this.quill_disabled = false
    })
  },

  methods: {

    removeInvalidFeedback () {
      this.inputValue.state = null
      this.inputValue.invalidFeedback = null
    }

  }

}
</script>

<style scoped>

.input-required {
  position: absolute;
  height: 1px;
  margin: -1px 0 0 0;
  padding: 0;
  border: none;
  z-index: -10;
}
.input-required:focus {
  box-shadow: none;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/RichTextField.vue